import { useEffect, useState } from "react";

export const useSvgTemplate = (templateSrc: string) => {
	const [svgContent, setSvgContent] = useState<string | null>(null);

	useEffect(() => {
		if (!templateSrc) return;

		fetch(templateSrc)
			.then((response) => response.text())
			.then((svgText) => {
				// No color replacement - just load the raw SVG
				const parser = new DOMParser();
				const svgDoc = parser.parseFromString(svgText, "image/svg+xml");
				const svgElement = svgDoc.querySelector("svg");

				if (!svgElement) {
					throw new Error("Invalid SVG template");
				}

				const innerContent = svgElement.innerHTML;
				setSvgContent(innerContent);
			})
			.catch((error) => {
				console.error(
					{ msg: "Error loading SVG template", src: templateSrc },
					error,
				);
			});
	}, [templateSrc]);

	return svgContent;
};
